
export const AttributeTurnOn = 'turn-on';
export const AttributeSkip = 'turn-on-skip';

export const windowName = 'window';

export const logPrefix = 'turn-on: ';